import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class TicketsRetidosService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(
    private tokenService: TokenService,
    private http: HttpClient
  ) { }

  getListaTicketsRetidos(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/chamadoRetencao/listAll`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  bloquearContrato(payload) {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/chamadoRetencao/contrato/bloquear`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  bloquearRemetente(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/chamadoRetencao/bloquear`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirChamadoRetido(id): Observable<any> {
    this.httpOptions.params = '';
    const _options = {
      headers: this.httpOptions.headers,
      body: {
        id: id
      },
    }
    return this.http.delete(`${this.apiUrl}api/chamadoRetencao/excluir`, _options)
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirTodosChamadosRetidos(): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/chamadoRetencao/excluir-todos`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  liberarContrato(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/chamadoRetencao/contrato/liberar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  liberarRemetente(payload): Observable<any> {
    this.httpOptions.params = '';
    return this.http.post(`${this.apiUrl}api/chamadoRetencao/liberar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getListaBlacklist(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/clienteEmailDominio/listagem-bloqueados`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  excluirEmailBlacklist(id): Observable<any> {
    this.httpOptions.params = '';
    return this.http.delete(`${this.apiUrl}api/clienteEmailDominio/excluir-bloqueado/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
